import loader from './loader.json';

export const animationsAb = {
	loader,
};
